@if (toast.showSuccess()) {
  <div class="toast toast--success" role="status" aria-live="polite">
    <span class="toast-icon toast-icon--success" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </span>
    <span class="toast-text">{{ toast.successMessage() }}</span>
  </div>
}
@if (toast.showError()) {
  <div class="toast toast--error" role="alert" aria-live="assertive">
    <span class="toast-icon toast-icon--error" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </span>
    <span class="toast-text">{{ toast.errorMessage() }}</span>
  </div>
}
